/**
 * Vite env access isolated in a single module so the rest of the invitation
 * service stays free of `import.meta` syntax, which babel-jest cannot parse.
 * Replaced with `env.mock.ts` under Jest via `moduleNameMapper`.
 */
interface InvitationSessionEnv {
  /** Invitation-service session endpoint, e.g. `https://invitation-service.ciam-dev.fielmann.com/invite/session`. */
  invitationSessionUrl?: string;
  /** Uses a local fixture session only while running the Vite development app. */
  isDevelopmentLike: boolean;
}

export function getInvitationSessionEnv(): InvitationSessionEnv {
  const env = import.meta.env;
  return {
    invitationSessionUrl: env?.VITE_INVITATION_SESSION_URL,
    isDevelopmentLike: env?.DEV === true,
  };
}
